// extracted by mini-css-extract-plugin
export default {"background":"MainContainerWithWindow_background__CkpA+","container":"MainContainerWithWindow_container__4ap+Z"};